import { Table, Input } from "antd";
import type { ColumnsType } from "antd/es/table";
import React from "react";
import "./roles.css";
import { useTranslation } from "react-i18next";
interface RolesListProps {
  roles: DataType[];
  loading: boolean;
  permissions: any;
  onCheckboxChange: (permissionId: number) => void;
  checkedPermissions: number[];
  tableKey: number;
}

interface DataType {
  id: number;
  form: string;
  children?: {}[];
  isChild: boolean;
  userNumber: number;
}

export const PermissionsList: React.FC<RolesListProps> = ({
  permissions,
  loading,
  onCheckboxChange,
  checkedPermissions,
  tableKey,
}) => {
  const { t } = useTranslation("common");
  const columns: ColumnsType<DataType> = [
    {
      title: `${t("form")}`,
      dataIndex: "resourceName",
      key: "resourceName",
      className: "table-header",
      width: "20rem",
    },
    {
      title: `${t("create")}`,
      key: "create",
      width: "20rem",
      render: (record) => {
        const isIncluded = checkedPermissions.includes(
          record.permissions[0].id
        );

        return (
          <Input
            className="chexboxstyle"
            type="checkbox"
            onChange={(e) => onCheckboxChange(record.permissions[0].id)}
            checked={isIncluded}
          />
        );
      },
    },
    {
      title: `${t("read")}`,
      key: "read",
      width: "20rem",
      render: (record) => {
        const isIncluded = checkedPermissions.includes(
          record.permissions[1].id
        );

        return (
          <Input
            className="chexboxstyle"
            type="checkbox"
            onChange={(e) => onCheckboxChange(record.permissions[1].id)}
            checked={isIncluded}
          />
        );
      },
    },

    {
      title: `${t("update")}`,
      key: "update",
      width: "20rem",
      render: (record) => {
        const isIncluded = checkedPermissions.includes(
          record.permissions[2].id
        );

        return (
          <Input
            className="chexboxstyle"
            type="checkbox"
            onChange={(e) => onCheckboxChange(record.permissions[2].id)}
            checked={isIncluded}
          />
        );
      },
    },
    {
      title: `${t("delete")}`,
      key: "delete",
      width: "20rem",
      render: (record) => {
        const isIncluded = checkedPermissions.includes(
          record.permissions[3].id
        );

        return (
          <Input
            className="chexboxstyle"
            type="checkbox"
            onChange={(e) => onCheckboxChange(record.permissions[3].id)}
            checked={isIncluded}
          />
        );
      },
    },
  ];

  return (
    <>
      <Table
        key={tableKey}
        columns={columns}
        dataSource={permissions}
        className="roles-list"
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        loading={loading}
        size="large"
        pagination={{ pageSize: 8 }}
        rowKey={(record) => record.id}
      />
    </>
  );
};
